"use client";

import { JoinPoolForm } from "@/components/pool/JoinPoolForm";
import type { Tournament } from "@/types";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
} from "@heroui/react";
import { useTranslations } from "next-intl";

interface JoinPoolModalProps {
  tournament: Tournament;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export function JoinPoolModal({
  tournament,
  isOpen,
  onOpenChange,
}: JoinPoolModalProps) {
  const t = useTranslations();

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="md"
      placement="top"
      scrollBehavior="inside"
      classNames={{
        base: "m-2 sm:m-4",
        wrapper: "items-start pt-[10vh] sm:items-center sm:pt-0",
        backdrop: "bg-black/80",
        body: "py-4",
        header: "border-b border-white/5 pb-4",
        closeButton:
          "top-3 right-3 hover:bg-white/10 active:bg-white/20 text-default-400",
      }}
    >
      <ModalContent className="bg-[#0f1219] border border-amber-500/20">
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">
              <div className="flex items-center gap-3 justify-center">
                <div className="h-px w-8 bg-gradient-to-r from-transparent to-amber-500/40" />
                <h2 className="font-cinzel text-xl font-bold text-amber-400 tracking-wide">
                  {t("tournaments.pool.modal.title")}
                </h2>
                <div className="h-px w-8 bg-gradient-to-l from-transparent to-amber-500/40" />
              </div>
              <p className="text-sm font-normal text-default-400 text-center">
                {t("tournaments.pool.modal.description", {
                  tournament: tournament.name,
                })}
              </p>
            </ModalHeader>
            <ModalBody className="pb-6">
              <JoinPoolForm
                tournament={tournament}
                onSuccess={onClose}
                onCancel={onClose}
              />
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
